var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBuscaBranca(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 15.999,
    height: 16,
    viewBox: "0 0 15.999 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "rect-1",
    width: 15.999,
    height: 16,
    x: 0,
    y: 0
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.999,
    height: 16,
    x: 0,
    y: 0,
    fill: "black"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "white",
    xlinkHref: "#rect-1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "none",
    xlinkHref: "#rect-1"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(189,189,189)",
    fillRule: "evenodd",
    d: "M2.09887695 1.57061768c2.47930909-2.19940186 6.24316407-2.08551026 8.58499146.25976562 2.13745117 2.14483643 2.4357605 5.51116943.70877075 7.99841309.25097656.05212402.48138428.17608642.663208.35681152l3.55435181 3.55596924c.5164795.51654053.5164795 1.35394287 0 1.87042236-.51647949.5164795-1.35388183.5164795-1.87036132 0l-3.55438233-3.55438232c-.18115234-.1815796-.30545044-.41204834-.35757446-.66320801-2.72106934 1.89215088-6.44534302 1.33581543-8.49465942-1.2689209-2.04934693-2.60479736-1.71365357-6.35540771.76565551-8.5548706zm.85565186 7.99249267c1.82510376 1.82513428 4.78417969 1.82519531 6.60934448.00006104h-.00161743c1.82260132-1.82598877 1.82330322-4.78271485.00161743-6.60961914-1.8251648-1.82507325-4.78424072-1.82501221-6.60934448.00012207-1.82510376 1.82513427-1.82510376 4.78424072 0 6.60943603z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuscaBranca);
export default __webpack_public_path__ + "static/media/busca_branca.188c00c2e42a79920c3df654270d9cb0.svg";
export { ForwardRef as ReactComponent };